import posthog from 'posthog-js';
import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Icon, { Icons } from '../../../../components/Icon/Icon';
import { t } from '../../../../lang';
import HelperService from '../../../../services/HelperService';
import { appSlice } from '../../../../store/slices';
import './AccountCard.scss';

const ICON_SIZE_W = 44;
const ICON_SIZE_H = 68;
const EYE_ICON_SIZE = 16;

const iconsBySymbol = {
	'USDT-TRC20': Icons.UsdtTrc20CoinBigBorder,
	'USDT-ERC20': Icons.UsdtErc20CoinBigBorder,
	TRX: Icons.TrxCoinBigBorder,
	ETH: Icons.EthCoinBigBorder,
	BTC: Icons.BtcCoinBigBorder,
};

const AccountCard = ({ account, activeCurrency }) => {
	const dispatch = useDispatch();
	const viewsBalances = useSelector(state => state?.app?.viewsBalances);

	return (
		<div className='AccountCard'>
			<div className='AccountCard-balances'>
				<div className='crypto'>
					{viewsBalances
						? HelperService.FormatCrypto(
								account?.Amount,
								HelperService.GetCurrencyPrecisionByName(activeCurrency?.Symbol)
						  )
						: '******'}
				</div>
				<div className='fiat'>
					$ {viewsBalances ? HelperService.FormatFiatWithoutCurrency(account?.AmountUsd) : '******'}
				</div>
			</div>

			<div className='AccountCard-body'>
				<div className='AccountCard-item item-top'>
					{account?.AddressLabel && <div className='lable'>{account?.AddressLabel}</div>}
					<Icon
						className='eye'
						onClick={() => dispatch(appSlice.actions.setViewsBalances(!viewsBalances))}
						type={Icons[viewsBalances ? 'EYE' : 'CROSSED_EYE']}
						width={EYE_ICON_SIZE}
						height={EYE_ICON_SIZE}
					/>
				</div>
				<button
					className='AccountCard-item item-bottom'
					onClick={() => {
						navigator.clipboard.writeText(account?.Address);

						posthog.capture('address_copied');

						HelperService.showNotification({
							type: 'success',
							body: t('Address copied'),
							autoHideDuration: 3000,
						});
					}}
				>
					<div className='address'>{account?.Address}</div>
				</button>
			</div>
		</div>
	);
};

AccountCard.propTypes = {
	account: PropTypes.object,
	activeCurrency: PropTypes.object,
};

export default AccountCard;
